export default __webpack_public_path__ + "static/media/popupcard@2x.f2692616.png";